import {
  AMAZON_STOREFRONT_URL,
  landingCopy,
  OWNED_BRANDS,
} from "./landingCopy"
import { useLandingLocale } from "./landingLocale"
import { LandingFooter, LandingHeader, useLandingDocument } from "./LandingShell"
import "./PublicLanding.css"

const PublicLanding = () => {
  const { locale, setLandingLocale, ready } = useLandingLocale()
  const copy = landingCopy(locale)

  useLandingDocument(locale, copy.metaTitle, copy.metaDescription)

  if (!ready) {
    return <div className="landing-page" aria-busy="true" aria-label="Loading" />
  }

  return (
    <div className="landing-page">
      <LandingHeader locale={locale} onLocaleChange={setLandingLocale} />

      <section className="landing-hero">
        <div className="landing-hero-inner">
          <h1>{copy.heroTitle}</h1>
          <p>{copy.heroSubtitle}</p>
          <div className="landing-hero-actions">
            <a className="landing-btn landing-btn-primary" href={AMAZON_STOREFRONT_URL} target="_blank" rel="noopener noreferrer">
              {copy.ctaAmazon}
            </a>
            <a className="landing-btn landing-btn-secondary" href="/impressum#contact">
              {copy.ctaContact}
            </a>
          </div>
        </div>
      </section>

      <section className="landing-section" id="about">
        <h2 className="landing-section-title">{copy.aboutTitle}</h2>
        <p className="landing-section-subtitle">{copy.aboutSubtitle}</p>
        <div className="landing-grid-2">
          <article className="landing-card">
            <h3>{copy.aboutCard1Title}</h3>
            <p>{copy.aboutCard1Body}</p>
          </article>
          <article className="landing-card">
            <h3>{copy.aboutCard2Title}</h3>
            <p>{copy.aboutCard2Body}</p>
          </article>
        </div>
      </section>

      <section className="landing-band is-muted" id="brands">
        <div className="landing-section landing-section-in-band">
          <h2 className="landing-section-title">{copy.brandsTitle}</h2>
          <p className="landing-section-subtitle">{copy.brandsSubtitle}</p>

          <div className="landing-grid-3">
            {OWNED_BRANDS.map(brand => (
              <article className="landing-card" key={brand.name}>
                <div className="landing-brand-logo-wrap">
                  <img
                    className={`landing-brand-logo ${brand.logoClass}`}
                    src={`${process.env.PUBLIC_URL}${brand.logo}`}
                    alt={brand.name}
                  />
                </div>
                <p>{copy[brand.bodyKey]}</p>
                {brand.href ? (
                  <a className="landing-card-link" href={brand.href} target="_blank" rel="noopener noreferrer">
                    {copy.visitBrand} →
                  </a>
                ) : null}
              </article>
            ))}
          </div>

          <article className="landing-card landing-partner-card">
            <span className="landing-tag landing-tag-partner">{copy.tagPartner}</span>
            <h3>{copy.partnerBrandsTitle}</h3>
            <p>{copy.partnerBrandsBody}</p>
          </article>
        </div>
      </section>

      <section className="landing-section" id="partners">
        <h2 className="landing-section-title">{copy.partnersTitle}</h2>
        <p className="landing-section-subtitle">{copy.partnersSubtitle}</p>
        <div className="landing-grid-2">
          <article className="landing-card">
            <h3>{copy.partnersCard1Title}</h3>
            <p>{copy.partnersCard1Body}</p>
          </article>
          <article className="landing-card">
            <h3>{copy.partnersCard2Title}</h3>
            <p>{copy.partnersCard2Body}</p>
          </article>
          <article className="landing-card">
            <h3>{copy.partnersCard3Title}</h3>
            <p>{copy.partnersCard3Body}</p>
          </article>
          <article className="landing-card">
            <h3>{copy.partnersCard4Title}</h3>
            <p>{copy.partnersCard4Body}</p>
          </article>
        </div>
        <div className="landing-section-cta">
          <a className="landing-btn landing-btn-primary" href="/impressum#contact">
            {copy.ctaPartners}
          </a>
        </div>
      </section>

      <section className="landing-band is-muted" id="careers">
        <div className="landing-section landing-section-in-band">
          <h2 className="landing-section-title">{copy.careersTitle}</h2>
          <p className="landing-section-subtitle">{copy.careersSubtitle}</p>
          <div className="landing-grid-2">
            <article className="landing-card">
              <h3>{copy.careersCard1Title}</h3>
              <p>{copy.careersCard1Body}</p>
            </article>
            <article className="landing-card">
              <h3>{copy.careersCard2Title}</h3>
              <p>{copy.careersCard2Body}</p>
            </article>
          </div>
          <div className="landing-section-cta">
            <a className="landing-btn landing-btn-secondary" href="/impressum#contact">
              {copy.ctaCareers}
            </a>
          </div>
        </div>
      </section>

      <LandingFooter locale={locale} />
    </div>
  )
}

export default PublicLanding
